"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const hopper_1 = require("services/master-data/hopper");
const hopper_types_1 = require("./hopper.types");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, hopper_1._getHopperData)(dataStates);
    if (response.isError) {
        const payload = {
            isError: response.isError,
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
        };
        dispatch({ type: hopper_types_1.hopperTypes.SET_ERROR, payload: payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { target_queue_time_display: item.target_queue_time ? item.target_queue_time + ' Minutes' : '', target_lead_time_display: item.target_lead_time ? item.target_lead_time + ' Minutes' : '', created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: hopper_types_1.hopperTypes.SET_DATA_GRID, payload: payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStates };
    dispatch({ type: hopper_types_1.hopperTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: hopper_types_1.hopperTypes.ON_MUTATION_CLICK, payload });
};
const onSaveDataItem = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode, dataItem } = payload;
    const response = mutationMode === 'add'
        ? yield (0, hopper_1._postHopperData)({
            hopper: dataItem.hopper,
            is_active: dataItem.is_active,
            hopper_type: dataItem.hopper_type,
            description: dataItem.description,
            target_lead_time: dataItem.target_lead_time,
            target_queue_time: dataItem.target_queue_time,
        })
        : yield (0, hopper_1._putHopperData)({
            id: dataItem.id,
            hopper: dataItem.hopper,
            is_active: dataItem.is_active,
            hopper_type: dataItem.hopper_type,
            description: dataItem.description,
            target_lead_time: dataItem.target_lead_time,
            target_queue_time: dataItem.target_queue_time,
        });
    if (response.isError) {
        dispatch({
            type: hopper_types_1.hopperTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            }
        });
    }
    else {
        dispatch({
            type: hopper_types_1.hopperTypes.ON_SAVE_DATAITEM,
            payload: {
                mutationMode,
                dataItem,
                isSuccess: !response.isError
            }
        });
    }
});
const onGetDataEnumHopper = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, hopper_1._getEnumHopperData)();
    if (response.isError) {
        dispatch({
            type: hopper_types_1.hopperTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: 'Error Fetching Enum Hopper Data. \n'.concat(response.errorMessage),
            }
        });
    }
    else {
        dispatch({ type: hopper_types_1.hopperTypes.SET_DATA_ENUM_HOPPER, payload: response.data });
    }
});
const onDeleteDataItem = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode, dataItem } = payload;
    const response = yield (0, hopper_1._deleteHopperData)({ id: dataItem.id });
    if (response.isError) {
        dispatch({
            type: hopper_types_1.hopperTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            }
        });
    }
    else {
        dispatch({
            type: hopper_types_1.hopperTypes.ON_DELETE_DATAITEM,
            payload: {
                dataItem,
                mutationMode,
                isSuccess: !response.isError
            }
        });
    }
});
const onFilterChange = payload => dispatch => {
    dispatch({ type: hopper_types_1.hopperTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: hopper_types_1.hopperTypes.ON_SORT_CHANGE, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: hopper_types_1.hopperTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const onLoading = () => dispatch => {
    dispatch({ type: hopper_types_1.hopperTypes.SET_LOADING, payload: true });
};
exports.default = {
    getDataGrid,
    onSaveDataItem,
    onClickMutation,
    onDeleteDataItem,
    onDataStateChange,
    onGetDataEnumHopper,
    onFilterChange,
    onSortChange,
    onCloseError,
    onLoading,
};
